import { render, staticRenderFns } from "./merchantDetail.vue?vue&type=template&id=78267586&scoped=true"
import script from "./merchantDetail.vue?vue&type=script&lang=js"
export * from "./merchantDetail.vue?vue&type=script&lang=js"
import style0 from "./merchantDetail.vue?vue&type=style&index=0&id=78267586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78267586",
  null
  
)

export default component.exports